import { Skeleton } from '@mui/material';

const CustomSkeleton = (props) => {
  return <Skeleton sx={{ bgcolor: '#F2F6FF' }} {...props} />;
};

export default CustomSkeleton;
